import { RootState } from "../types";

const initialState: RootState = {
    auth: {
        user: null
    },
    notifications: []
}

export default initialState;